const Sdata = [
  {
    id: 1,
    cover: "/Images/slide-1.jpg",
    category: "lifestyle",
    title: "What are the best countries to visit?",
    desc: "In this post, we are going to highlight the many benefits of blogging for business and how you can get started with",
  },
  {
    id: 2,
    cover: "/Images/slide-2.jpg",
    category: "lifestyle",
    title: "What are the best countries to visit?",
    desc: "In this post, we are going to highlight the many benefits of blogging for business and how you can get started with",
  },
  {
    id: 3,
    cover: "/Images/slide-3.jpg",
    category: "lifestyle",
    title: "What are the best countries to visit?",
    desc: "In this post, we are going to highlight the many benefits of blogging for business and how you can get started with",
  },
]

export default Sdata
